<template>
  <v-container fluid class="app">
    <v-erro
      :icone="icone"
      :nomeDoErro="nomeDoErro"
      :mensagemDeErro="mensagemDeErro" />
  </v-container>
</template>

<script>
import VErro from "../components/VErro.vue"
export default {
  name: "AcessoNegado",
  components: {
    VErro,
  },
  data() {
    return {
      icone: "mdi-account-off",
      nomeDoErro: "Acesso negado",
      mensagemDeErro: "Você não tem acesso a esta página.",
    }
  },
}
</script>
